import React from 'react';
import { User } from '../../types/user';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { ArrowLeft } from 'lucide-react';

interface UserViewProps {
  user: User;
  onBack: () => void;
}

export const UserView: React.FC<UserViewProps> = ({ user, onBack }) => {
  const displayValue = (value: any) => {
    if (value === null || value === undefined || value === '') {
      return 'Not Provided';
    }
    return value;
  };

  return (
    <div className="container mx-auto p-6">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between">
          <div className="flex items-center gap-4">
            <Button
              variant="ghost"
              size="icon"
              onClick={onBack}
              className="h-8 w-8"
            >
              <ArrowLeft className="h-4 w-4" />
            </Button>
            <CardTitle>User Details</CardTitle>
          </div>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-4">
              <div>
                <h3 className="text-lg font-medium mb-4">User Information</h3>
                <div className="space-y-3">
                  <div>
                    <label className="text-sm text-muted-foreground">Username</label>
                    <p className="font-medium">{displayValue(user.username)}</p>
                  </div>
                  <div>
                    <label className="text-sm text-muted-foreground">Name</label>
                    <p className="font-medium">{displayValue(user.name)}</p>
                  </div>
                  <div>
                    <label className="text-sm text-muted-foreground">Role</label>
                    <p className="font-medium capitalize">{displayValue(user.role)}</p>
                  </div>
                  <div>
                    <label className="text-sm text-muted-foreground">Status</label>
                    <p className="font-medium capitalize">{user.isActive ? 'Active' : 'Inactive'}</p>
                  </div>
                  <div>
                    <label className="text-sm text-muted-foreground">Seller Type</label>
                    <p className="font-medium capitalize">{displayValue(user.sellerType)}</p>
                  </div>
                  <div>
                    <label className="text-sm text-muted-foreground">Location</label>
                    <p className="font-medium">{displayValue(user.location)}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="space-y-4">
              <div>
                <h3 className="text-lg font-medium mb-4">Additional Details</h3>
                <div className="space-y-3">
                  <div>
                    <label className="text-sm text-muted-foreground">Current Belt</label>
                    <p className="font-medium capitalize">{displayValue(user.currentBelt)}</p>
                  </div>
                  <div>
                    <label className="text-sm text-muted-foreground">Total Points</label>
                    <p className="font-medium">{displayValue(user.totalPoints)}</p>
                  </div>
                  <div>
                    <label className="text-sm text-muted-foreground">Distributor Code</label>
                    <p className="font-medium">{displayValue(user.distributorCode)}</p>
                  </div>
                  <div>
                    <label className="text-sm text-muted-foreground">Trainer Code</label>
                    <p className="font-medium">{displayValue(user.trainerCode)}</p>
                  </div>
                  <div>
                    <label className="text-sm text-muted-foreground">Created At</label>
                    <p className="font-medium">
                      {user.createdAt ? new Date(user.createdAt).toLocaleDateString() : 'Not Provided'}
                    </p>
                  </div>
                  <div>
                    <label className="text-sm text-muted-foreground">Modified At</label>
                    <p className="font-medium">
                      {user.modifiedAt ? new Date(user.modifiedAt).toLocaleDateString() : 'Not Provided'}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}; 